/** How far into the past a worker class may be planned. Values are the API names; the API rejects numeric strings. */
export enum PlanningInThePastState {
  NOT_ALLOWED = 'NotAllowed',
  SAME_DAY_ONLY = 'SameDayOnly',
  FULLY_ALLOWED = 'FullyAllowed',
}
